import React from 'react'
import { AuthoringUtils, PathUtils } from '@adobe/aem-spa-page-model-manager'
import { Slider, SliderProps } from '@dcxwam/dcx-wam-ui-foundations'
import Container from '../../Container/Container'
import ExperienceFragmentContent from '../../ExperienceFragmentContent/ExperienceFragmentContent'
import { EditableComponentPropsType } from '../../../../utils/prop-types'
import { ContainerModelProps } from '../../Container/types'
import { EXPERIENCE_FRAGMENT } from '../../../../utils/constants'

interface GetSliderComponentProps {
  props: EditableComponentPropsType<ContainerModelProps>
  xfPath?: string
  sliderConfig?: SliderProps
  renderComponent?: React.ReactElement | null
}

export const getSliderComponent = ({
  props,
  xfPath,
  sliderConfig,
  renderComponent
}: GetSliderComponentProps): React.ReactElement => {
  const hasExperienceFragment =
    PathUtils.getCurrentURL().includes(EXPERIENCE_FRAGMENT)

  let componentToDisplay = <Container {...props} />

  if (AuthoringUtils.isInEditor()) {
    if (!hasExperienceFragment && xfPath) {
      componentToDisplay = <ExperienceFragmentContent model={{ xfPath }} />
    }
  } else {
    componentToDisplay = renderComponent || <Slider {...sliderConfig} />
  }

  return componentToDisplay
}
